import { render, staticRenderFns } from "./work-item-row.component.vue?vue&type=template&id=6b9506ab&scoped=true&"
import script from "./work-item-row.component.vue?vue&type=script&lang=ts&"
export * from "./work-item-row.component.vue?vue&type=script&lang=ts&"
import style0 from "./work-item-row.component.vue?vue&type=style&index=0&id=6b9506ab&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9506ab",
  null
  
)

export default component.exports